var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-center mb-4 mt-4"},[_vm._v("已报备项目")]),_c('div',{staticClass:"page-title-desc text-center mb-4 mt-4"},[_vm._v("查看已报备项目结果、有效期，如有疑问请联系 010-64361972")]),_c('page-body',[_c('report-project-list',{attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }